export const USER_LOCAL_STORAGE_NAME = 'kiaraUser';
export const LANGUAGE_LOCAL_STORAGE_NAME = 'language';
